import request from "@/utils/request";

// 查询企业剩余额度
export const  resourceInfo =(query) =>{
    return request({
        url: "/businessservice/analyseResource/resourceInfo",
        method:"get",
        params: query
    })
}

// 查询平台分配额度
export const  ptInfo =(query) =>{
    return request({
        url: "/businessservice/analyseResource/info",
        method:"get",
        params: query
    })
}

// 查询单位资源详情及记录
export const  analyseDetail =(query) =>{
    return request({
        url: "/businessservice/analyseResource/detail",
        method:"get",
        params: query
    })
}


// 开通教学分析单位
export const  createAnalyseOrg =(data) =>{
    return request({
        url: "/businessservice/analyseResource/create",
        method:"post",
        data: data
    })
}

// 分页查询教学分析资源
export const  pageAnalyseOrg =(data) =>{
    return request({
        url: "/businessservice/analyseResource/page",
        method:"post",
        data: data
    })
}

// 额度充值
export const  rechargeResource =(data) =>{
    return request({
        url: "/businessservice/analyseResource/recharge",
        method:"post",
        data: data
    })
}

// 查询用户管理单位资源详情及记录
export const  orgAnalyseDetail =(query) =>{
    return request({
        url: "/businessservice/analyseResource/userDetail",
        method:"get",
        params: query
    })
}